var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState } from 'react';
import styled, { ThemeProvider, withTheme, } from '@empiriecom/module-components/utils/styled-components';
import { animated, useSpring } from 'react-spring';
import cuid from 'cuid';
import usePrevious from '@empiriecom/module-components/hooks/usePrevious';
import useMeasure from '@empiriecom/module-components/hooks/useMeasure';
import useIcon from '@empiriecom/module-components/utils/getIcon';
import collapseTheme from './theme';
import CollapseWrapper from './Wrapper';
export var TestIds;
(function (TestIds) {
    TestIds["content"] = "collapse__content";
    TestIds["header"] = "collapse__header";
})(TestIds || (TestIds = {}));
var CollapseHeader = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n\n  .icon-open {\n    width: 1rem;\n    height: 1rem;\n  }\n"], ["\n  border: none;\n\n  .icon-open {\n    width: 1rem;\n    height: 1rem;\n  }\n"])));
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 0 1rem 0;\n"], ["\n  padding: 0 0 1rem 0;\n"])));
var AnimatedContentWrapper = styled(animated.div)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: hidden;\n  will-change: height;\n"], ["\n  overflow: hidden;\n  will-change: height;\n"])));
var Close = useIcon('Cancel');
var Collapse = function (_a) {
    var children = _a.children, headline = _a.headline, initialIsOpen = _a.initialIsOpen, propsIsOpen = _a.isOpen, onToggle = _a.onToggle, _b = _a.styleType, styleType = _b === void 0 ? 'default' : _b;
    // If propsIsOpen is provided the component will be controlled from the outside --> onToggle is required
    if (propsIsOpen !== undefined && onToggle === undefined) {
        throw new Error('You have to provide onToggle if isOpen is provided. Providing isOpen turns the component into a controlled component (= another component controls the state of this component). If you just want to provide the initial open state, use `initialIsOpen` instead.');
    }
    var _c = useState(initialIsOpen || false), stateIsOpen = _c[0], setStateIsOpen = _c[1];
    var isOpen = propsIsOpen !== undefined ? propsIsOpen : stateIsOpen;
    var contentId = "collapse-content-" + cuid();
    // These hooks are required for the animation
    var previous = usePrevious(isOpen);
    var _d = useMeasure(), ref = _d[0], contentHeight = _d[1].height;
    var animatedHeight = useSpring({
        config: { duration: 200 },
        height: isOpen ? contentHeight : 0,
    }).height;
    var onHeaderClick = function () {
        if (onToggle !== undefined) {
            onToggle();
        }
        else {
            // Component is uncontrolled --> Manages its own state
            setStateIsOpen(function (isHeaderOpen) { return !isHeaderOpen; });
        }
    };
    return (React.createElement(ThemeProvider, { theme: collapseTheme },
        React.createElement(CollapseWrapper, { styleType: styleType, isOpen: isOpen },
            React.createElement(CollapseHeader, { "aria-controls": contentId, "aria-expanded": isOpen, "data-testid": TestIds.header, isOpen: isOpen, onClick: onHeaderClick, type: "button" },
                React.createElement("span", { className: "icon " + (isOpen ? 'open' : 'close') },
                    React.createElement(Close, { className: "icon-open" })),
                React.createElement("span", { className: "label" }, headline)),
            React.createElement(AnimatedContentWrapper, { "aria-hidden": !isOpen, style: {
                    height: isOpen && previous === isOpen ? 'auto' : animatedHeight,
                } },
                React.createElement("div", { ref: ref },
                    ' ',
                    React.createElement(Content, { "data-testid": TestIds.content, id: contentId }, children))))));
};
export default withTheme(Collapse);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map